(() => {
  const button = document.querySelector('.menu-toggle');
  const menu = document.getElementById('mobile-menu');
  const setMenuOpen = (open, restoreFocus = false) => {
    if (!button || !menu) return;
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    menu.hidden = !open;
    if (!open && restoreFocus) button.focus();
  };
  if (button && menu) {
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      setMenuOpen(open);
    });
  }

  const dropdowns = [...document.querySelectorAll('[data-nav-dropdown]')];
  const closeDropdowns = (except) => dropdowns.forEach((item) => {
    if (item !== except) item.open = false;
  });
  dropdowns.forEach((item) => {
    const summary = item.querySelector('summary');
    summary.setAttribute('aria-expanded', String(item.open));
    item.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(item.open));
      if (item.open) closeDropdowns(item);
    });
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-nav-dropdown]')) closeDropdowns();
    if (menu && !menu.hidden && !menu.contains(event.target) && !button.contains(event.target)) setMenuOpen(false);
    if (event.target.closest('.nav-dropdown__links a, .mobile-menu > a')) {
      closeDropdowns();
      if (button && menu && !menu.hidden) {
        setMenuOpen(false);
      }
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const active = dropdowns.find((item) => item.open);
    if (active) {
      active.open = false;
      active.querySelector('summary').focus();
      event.preventDefault();
    } else if (button && menu && !menu.hidden) {
      setMenuOpen(false, true);
      event.preventDefault();
    }
  });
  document.addEventListener('focusin', (event) => {
    dropdowns.forEach((item) => { if (!item.contains(event.target)) item.open = false; });
  });

  window.matchMedia('(min-width: 831px)').addEventListener('change', (event) => {
    if (event.matches) { setMenuOpen(false); closeDropdowns(); }
  });

  const mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('.product-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.imageUrl;
      mainImage.alt = thumb.dataset.imageAlt || '';
      mainImage.removeAttribute('srcset');
      document.querySelectorAll('.product-thumb').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  const variantSelect = document.getElementById('ProductVariant');
  const price = document.getElementById('ProductPrice');
  const compare = document.getElementById('ComparePrice');
  if (variantSelect && price) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      if (!option) return;
      price.textContent = option.dataset.price || price.textContent;
      if (compare) {
        compare.textContent = option.dataset.comparePrice || '';
        compare.hidden = !option.dataset.comparePrice;
      }
    });
  }
})();
